import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useContent } from "@/context/ContentContext";
import { canSeePage } from "@/lib/pages";
import { Swords, ChevronRight } from "lucide-react";

const CWX_CSS = `
.cwx-plate{position:relative;border:0;padding:0;background:transparent url('/icons/cwx-entry-plate.png') center/100% 100% no-repeat;cursor:pointer;animation:cwxGold 2.8s ease-in-out infinite}
.cwx-plate:hover{animation:none;filter:brightness(1.18) drop-shadow(0 0 26px rgba(250,204,21,.85)) drop-shadow(0 8px 16px rgba(0,0,0,.6))}
@keyframes cwxGold{0%,100%{filter:drop-shadow(0 0 8px rgba(250,204,21,.4)) drop-shadow(0 6px 12px rgba(0,0,0,.55))}50%{filter:drop-shadow(0 0 20px rgba(250,204,21,.8)) drop-shadow(0 6px 12px rgba(0,0,0,.55))}}
.cwx-inner{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;gap:.6rem;padding:0 .9rem;text-align:center}
.skybox-float{background:transparent;border:0;padding:0 .25rem;cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;animation:skyFloat 3.6s ease-in-out infinite}
.skybox-float img{height:56px;width:auto;filter:drop-shadow(0 4px 10px rgba(0,0,0,.6)) drop-shadow(0 0 12px rgba(250,215,130,.35));transition:transform .25s ease,filter .25s ease}
.skybox-float:hover img{transform:scale(1.12) translateY(-2px);filter:drop-shadow(0 6px 14px rgba(0,0,0,.6)) drop-shadow(0 0 28px rgba(250,215,130,.9))}
.skybox-float .skybox-lbl{font-weight:900;font-size:8px;letter-spacing:.3em;text-transform:uppercase;background:linear-gradient(180deg,#FFF3C4,#E7C566 55%,#B98A2E);-webkit-background-clip:text;background-clip:text;color:transparent}
.skybox-float:hover .skybox-lbl{text-shadow:0 0 12px rgba(231,197,102,.6)}
@keyframes skyFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-4px)}}
`;

export default function CardWarsEntry({ testId = "cardwars-entry" }) {
  const { user } = useAuth();
  const content = useContent()?.content || {};
  const navigate = useNavigate();
  if (!canSeePage(user, content["access.card-wars"])) return null;
  return (
    <div className="flex items-center gap-3 mb-4">
      <style>{CWX_CSS}</style>
      <button data-testid={testId} onClick={() => navigate("/card-wars")}
        className="cwx-plate group flex-1 min-w-0 h-[84px] transition-transform active:scale-[0.985]">
        <span className="cwx-inner">
          <Swords className="w-4 h-4 shrink-0 text-yellow-300" style={{ filter: "drop-shadow(0 0 6px rgba(250,204,21,.8))" }} />
          <span className="min-w-0">
            <span className="block font-display font-black uppercase tracking-[0.08em] text-[13px] sm:text-[15px] whitespace-nowrap text-[#FDE68A]"
              style={{ textShadow: "0 1px 2px rgba(0,0,0,.9), 0 0 10px rgba(250,204,21,.8), 0 0 24px rgba(250,204,21,.4)" }}>
              Bullpen: Card Wars
            </span>
            <span className="block text-[8px] uppercase tracking-[0.22em] whitespace-nowrap text-amber-100/90"
              style={{ textShadow: "0 1px 2px rgba(0,0,0,.9)" }}>
              Your deck · Enter the arena
            </span>
          </span>
          <ChevronRight className="w-4 h-4 text-yellow-300 shrink-0 group-hover:translate-x-1 transition-transform" />
        </span>
      </button>
      <button data-testid={`${testId}-skybox`} onClick={() => navigate("/card-wars?skybox=1")}
        title="The Skybox — your private suite above the arena. Watch the battles. Call the winners."
        className="skybox-float shrink-0 active:scale-95 transition-transform">
        <img src="/icons/skybox-emblem.png" alt="Skybox" draggable="false" />
        <span className="skybox-lbl">Skybox</span>
      </button>
    </div>
  );
}
